(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aigod-share]');
    if (!btn) return;
    var wrap = btn.closest('.aigod-share');
    var toast = wrap ? wrap.querySelector('.aigod-share__toast') : null;
    var url = window.location.href;
    var title = document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        if (toast) { toast.textContent = 'Link copied'; setTimeout(function () { toast.textContent = ''; }, 2000); }
      });
    } else {
      window.prompt('Copy this link', url);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
